var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 24.375C20.1776 24.375 24.375 20.1776 24.375 15C24.375 9.82233 20.1776 5.625 15 5.625C9.82233 5.625 5.625 9.82233 5.625 15C5.625 20.1776 9.82233 24.375 15 24.375ZM15 26.25C21.2132 26.25 26.25 21.2132 26.25 15C26.25 8.7868 21.2132 3.75 15 3.75C8.7868 3.75 3.75 8.7868 3.75 15C3.75 21.2132 8.7868 26.25 15 26.25ZM15.9375 18.75V20.625H14.0625V18.75H15.9375ZM13.125 13.0398C13.125 12.0783 13.9371 11.25 15 11.25C16.0629 11.25 16.875 12.0783 16.875 13.0398C16.875 13.4237 16.6439 13.8789 16.1345 14.3949C15.6408 14.8951 15.013 15.3241 14.491 15.6615L14.0625 15.9386V17.8125H15.9375V16.9529C16.414 16.6287 16.9785 16.2089 17.469 15.712C18.1023 15.0705 18.75 14.162 18.75 13.0398C18.75 10.9888 17.0436 9.375 15 9.375C12.9564 9.375 11.25 10.9888 11.25 13.0398H13.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenter);
export default __webpack_public_path__ + "static/media/help_center.8887f9a9fb4d58d3617047455c9c40be.svg";
export { ForwardRef as ReactComponent };